/**
 * Created by zhangxiaoqing on 2017/7/19.
 */
import * as types from '../mutation-types'
import userService from '@/api/userService.js'
// import config from '@/assets/js/config.js'
// initial state
// shape: [{ id, quantity }]
const state = {
  // domain:'', // 保存后台请求的地址，修改时方便（比方说从测试服改成正式服域名）
  userInfo: {}
}

// getters
const getters = {
  userInfo: (state) => state.userInfo
}

// actions
const actions = {
  getLoginUser(context, obj){
    let TOKEN = obj.TOKEN;
    let unGetPermission = obj.unGetPermission;
    let next = obj.next;
    let param = TOKEN ? {TOKEN: TOKEN} : {}
    userService.getResponse('getLoginUser', param).then((response) => { // 需要用户信息则校验登录
      //当第一次调登录时给sensors添加登录信息，切换路由不重复添加 
      if(!context.getters.userInfo.memberCode){
        sensors.login(response.user.memberCode)
      } 
      context.commit(types.UPDATEUSERINFO, response.user)
      let tenantId = response.tenantId;
      tenantId && context.commit(types.UPDATETENANTID, tenantId);
      next()
      !unGetPermission && context.dispatch('getRoleIds', response.user)
    }).catch(() => {
      context.commit(types.UPDATEUSERINFO, {})
    })
  }

}

// mutations
const mutations = {
  [types.UPDATEUSERINFO] (state, userInfo) {
    state.userInfo = userInfo
  },

  updateGroupId (state, val) {
    state.groupId = val;
    val ? window.localStorage.setItem('groupId',val) : window.localStorage.removeItem('groupId')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js